import { Modal } from "antd";
import Lottie from "lottie-react";
import SplashSpinner from "../assets/animation/common_spinner.json";

const Loader = () => {
  return (
    <div className="splash-container">
      <Lottie animationData={SplashSpinner} loop={true} className="splash-animation" />
    </div>
  );
};

export { Loader };
